import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useSEO } from "@/lib/seo";
import { resolveLegacy } from "@/lib/legacyRedirects";

export default function NotFound() {
  const { pathname } = useLocation();
  useSEO({ title: "Page Not Found", description: "The page you're looking for doesn't exist." });

  // Self-heal legacy Wakad-site URLs that land on the Pune app.
  const legacy = resolveLegacy(pathname);
  if (legacy && legacy !== pathname) return <Navigate to={legacy} replace />;

  return (
    <div className="ec-container py-32 text-center" data-testid="not-found">
      <p className="font-display text-7xl text-primary">404</p>
      <h1 className="font-display text-2xl text-foreground mt-4">Page not found</h1>
      <p className="text-muted-foreground mt-2 max-w-md mx-auto">The page you're looking for may have moved or no longer exists.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/" className="h-11 px-6 inline-flex items-center rounded-md bg-primary text-primary-foreground text-sm font-semibold">Back to Home</Link>
        <Link to="/projects" className="h-11 px-6 inline-flex items-center rounded-md border border-primary text-primary text-sm font-semibold">Browse Projects</Link>
      </div>
    </div>
  );
}
